<!-- 我的页面 -->
<template>
  <div>
    <div class="layer-4" id="tb-YSF-BTN-HOLDER1" @click="openFloat">
      <div id="tb-YSF-CUSTOM-ENTRY-4" class="YSF-CUSTOM-ENTRY">
        <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202306/50e798a68f43e5d67529fb9aef3285d1.png">
        </div>
      </div>
     <div class="modal-custom" v-if="showInfo">
            <div :class="['modal-info',showInfo&&showAni?'show':'hide']">
             <div class="modal-item" style="border-bottom: 1px solid rgba(0,0,0,.2);">视频顾问<a class="urllink" :href="url_link"></a></div>
             <div class="modal-item" @click="openKefu">在线顾问</div>
             <div class="modal-item cancel" @click="cancelFloat">取消</div>
            </div>
          </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      url_link:'',
      showInfo:false,
      showAni:false,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.getMpUrl()
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    openKefu(type){
      ysf('open')
    },
    openFloat(){
      this.showInfo=true;
      setTimeout(() => {
        this.showAni=true
      }, 300);
   
    },
    cancelFloat(){
      this.showInfo=false;
      this.showAni=false
   
    },
    getMpUrl(){
      let uuid='134';
      let url='https://auth.getconnectplus.com/url/link';
      let params = {
        store_id: '5f6d97f2-b266-47cb-af56-72855f4c93bf',
        path: 'packageSub/pages/chatail/index',
        query: 'uuid=' + uuid,
      };
      this.$http.post(url, this.$qs.stringify(params)).then(res => {
         if(res.data.errcode==0&&res.data.errmsg=='ok'){
           this.url_link=res.data.url_link
         }
      })
    }
  }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.modal-custom{
  display: none;
}
#tb-YSF-BTN-HOLDER1 {
    position: fixed;
    max-width: 70px;
    max-height: 70px;
    right: 30px;
    bottom: 24px;
    cursor: pointer;
    overflow: visible;
    filter: alpha(opacity=100);
    opacity: 1;
    z-index: 9990;
    display: none;
}
#tb-YSF-BTN-HOLDER:hover {
    filter: alpha(opacity=95);
    opacity: .95;
}
#tb-YSF-CUSTOM-ENTRY-4 {
    position: relative;
    width: auto;
    background-color: #5d5d5d;
    border-radius: 50%;
    box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.25);
}
@media screen and (max-width: 768px) {

  #tb-YSF-BTN-HOLDER1{
    display: block!important;;
  }
  #YSF-CUSTOM-ENTRY-4{
    display: none!important
  }
  .modal-custom{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 99999;
    display: block;
    background: rgba(0,0,0,0.6);
    .modal-info{
      position: fixed;
      width: 100%;
      bottom: 0;
      background: #EDEDED;
      z-index: 9999999;
      bottom: -100%;
      &.show{
        bottom: 0;
        transition: all .5s ease-in;
      }
      &.hidden{
        transform: translateY(100%);
        transition: all .5s ease-in;
      }
    }
    .modal-item{
      position: relative;
      width: 100%;
      height: 50px;
      line-height:50px;
      text-align: center;
      background: #ffffff;
      font-size: 16px;
      box-sizing: border-box;
      .urllink{
        position:absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
      &.cancel{
        margin-top: 7px;
      }
   
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/FloatingButton.vue